function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

export var defaultPluralizer = function defaultPluralizer(_i18n, count) {
  switch (count) {
    case 0:
      return ["zero", "other"];

    case 1:
      return ["one"];

    default:
      return ["other"];
  }
};
export var Pluralization =
/*#__PURE__*/
function () {
  function Pluralization(i18n) {
    _classCallCheck(this, Pluralization);

    this.i18n = i18n;
    this.registry = {};
    this.register("default", defaultPluralizer);
  }

  _createClass(Pluralization, [{
    key: "register",
    value: function register(locale, pluralizer) {
      this.registry[locale] = pluralizer;
    }
  }, {
    key: "get",
    value: function get(locale) {
      return this.registry[locale] || this.registry[this.i18n.locale] || this.registry["default"];
    }
  }]);

  return Pluralization;
}();